// src/RoleManagement.js

import React, {useEffect, useState} from 'react';
import { Table, Button, Switch, Tooltip, Row, Col, Dropdown, Menu,Modal, Form,AutoComplete,
  Cascader,
  Checkbox,
  Input,
  InputNumber,
  Space,
  Select} from 'antd';
  import { MoreOutlined } from "@ant-design/icons";
import { ServiceUtils } from '../../../Shared/Utils/ServiceUtils';
import { alertService } from '../../../Shared/Utils/ToasterUtils';
import { useNavigate } from 'react-router-dom';
import { getDecryptSession } from '../../../Shared/Utils/CommonUtils';
import { useSharedState } from '../../../Shared/Services/WindowSizeService';
import classNames from "classnames";


const RoleManagement = () => {


  const navigate = useNavigate();
  const windowSize$ = useSharedState();

  const [roleList, setRoleList] = useState({
    tableData: {
        headerContent: [],
        bodyContent: []
    }
  });
  const [userDetails, setUserDetails] = useState({});

  const handleActions = (data, action) => {
    if (action === "edit") {
      localStorage.setItem('subdept_id',data.subdept_id)
      navigate(`/admin/addEditDepartment/${data?.dept_id}`);
    } else if (action === "delete") {
    }
  };

   const menu = (record) => (
     <Menu>
       <Menu.Item key="edit" onClick={() => handleActions(record, "edit")}>
         Edit
       </Menu.Item>
     </Menu>
   );

const getRoleDetails = () => {
  ServiceUtils.getRequest('deptSubdept').then(
    (response) => {
      if (response.status === 200 && response?.data.status) {
        let res = JSON.parse(JSON.stringify(response.data?.data));
        console.log(res,"res")
        res?.headerContent?.map((el) => {
          if (el.key === "action") {
            el.render = (_, record) => (
              <Dropdown overlay={menu(record)} trigger={["click"]}>
                <Button type="link" icon={<MoreOutlined />} />
              </Dropdown>
            );
          }
        });
        setRoleList(res)
      } 
      else if(response.status === 401 ){
        navigate('/logout');
      }
      else {
        alertService.error(response.data.message)
      }
    },
    (error) => {
      // alertService.error('Error while fetching data')
      console.log(error)
    }
  );
}

  useEffect(()=>{
    const session = localStorage.getItem("arcutis-user");
    const userDetails = getDecryptSession(session);
    setUserDetails(userDetails);
    if(userDetails.admin_access){
      getRoleDetails()
    }
  },[])

  return (
    <div className="role-management">
      <Row style={{ width: "100%", margin: "5px" }}>
        <Col
          xs={{ flex: "100%" }}
          sm={{ flex: "100%" }}
          md={{ flex: "100%" }}
          lg={{ flex: "50%" }}
          xl={{ flex: "50%" }}
        >
          <div
            className={classNames("", {
              "search-kol-mobile":
                windowSize$ === "lg" ||
                windowSize$ === "xl" ||
                windowSize$ === "xxl",
              "search-kol-mobile":
                windowSize$ === "xs" ||
                windowSize$ === "sm" ||
                windowSize$ === "md",
            })}
          >
            <div></div>
          </div>
        </Col>
        <Col
          xs={{ flex: "100%" }}
          sm={{ flex: "100%" }}
          md={{ flex: "100%" }}
          lg={{ flex: "50%" }}
          xl={{ flex: "50%" }}
        >
          <div
            className={classNames("", {
              "search-kol-mobile":
                windowSize$ === "lg" ||
                windowSize$ === "xl" ||
                windowSize$ === "xxl",
              "search-kol-mobile":
                windowSize$ === "xs" ||
                windowSize$ === "sm" ||
                windowSize$ === "md",
            })}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                margin: "3px",
                padding: "3px"
              }}
            >
              <div style={{ padding: "2px" }}>
                <Button
                  type="primary"
                  onClick={() => navigate(`/admin/addDepartment`)}
                  style={{ marginBottom: 16 }}
                >
                  Add Department
                </Button>
              </div>
              <div style={{ padding: "2px" }}>
                <Button
                  type="primary"
                  onClick={() => navigate(`/admin/addSubDepartment`)}
                  style={{ marginBottom: 16 }}
                >
                  Add SubDepartment
                </Button>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <div
        className={classNames("", {
          "survey-container":
            windowSize$ === "lg" ||
            windowSize$ === "xl" ||
            windowSize$ === "xxl",
          "survey-container-small":
            windowSize$ === "xs" ||
            windowSize$ === "sm" ||
            windowSize$ === "md",
        })}
      >
        <Table
          columns={roleList?.headerContent}
          dataSource={roleList?.bodyContent}
          scroll={{ x: true, y: 400 }}
          pagination={false}
          bordered
        />
      </div>
    </div>
  );

}

export default RoleManagement;
